import { JobStatusFilter } from 'src/graphql/__generated__';

import type { QueryParamTab } from '../useQueryParam';

export const defaultStatuses: JobStatusFilter[] = [
  JobStatusFilter.ACTIVE,
  JobStatusFilter.BLOCKED,
  JobStatusFilter.PENDING_ACCOUNT_APPROVAL,
  JobStatusFilter.SUSPENDED,
];

export const mapTabToStatusFilters = (
  tab?: QueryParamTab,
): JobStatusFilter[] => {
  const mapper: Record<QueryParamTab, JobStatusFilter[]> = {
    open: defaultStatuses,
    expired: [JobStatusFilter.EXPIRED],
    draft: [],
  };

  if (!tab) {
    return defaultStatuses;
  }

  return mapper[tab];
};
